import {
  createDocument,
  updateDocument,
  deleteDocument,
  getDocument,
  getCollection,
} from "./FirebaseService";
import { getDocs, collection, query, orderBy, startAt, endAt, where,
  limit as limitFn, firestore, getDoc } from "firebase/firestore";
import { db } from "../auth/firebase";

const COLLECTION = "commissions";

const mapToAgent = (studentId, agentId, data) => ({
  studentId: studentId,
  agentId: agentId,
  commissions: data, // array of commissions exactly as in state
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
});

export async function updateStudentAgentCommissions(id, studentId, agentId, data) {
  try {
    const payload = mapToAgent(studentId, agentId, data);

    // Create or update the Firestore document
    await createDocument(COLLECTION, payload, id);

    // Fetch and return updated document
    const updatedDoc = await getDocument(COLLECTION, id);

    return { id, ...updatedDoc };
  } catch (err) {
    console.error("Error updating student agent commissions:", err);
    throw err;
  }
}



export const getCommission = async (id) => await getDocument(COLLECTION, id);

/**
 * Fetch commission records by studentId and optionally filter by agentId.
 * 
 * @param {string} studentId - The studentId value (e.g. "CIET123 [test]").
 * @param {string|null} agentId - Optional agentId (e.g. "A342").
 * @returns {Promise<Array>} Array of matching commission records.
 */
export const getStudentAgentCommissions = async (studentId, agentId = null) => {
  try {
    let q = query(collection(db, COLLECTION), where("studentId", "==", studentId));

    const snapshot = await getDocs(q);
    if (snapshot.empty) return [];

    const results = snapshot.docs
      .map((doc) => ({ id: doc.id, ...doc.data() }))
      .filter((data) => {
        if (!agentId) return true; // no filter → return all for that student
        // match agentId either at root or inside formState
        return data.agentId === agentId || data.formState?.agentId === agentId;
      });

    return results;
  } catch (err) {
    console.error("Error fetching commissions:", err);
    throw err;
  }
}